import axios from "axios";
import router from "../router";

export default () => {
  var api = axios.create({
    baseURL: `https://lestarijayaraya.co.id:10433/api/v2`,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-dreamfactory-api-key":
        "b1aa712948b72079c3b38179e2dd3c2caf72448ea99b3e0e98e6b3d0551faef1"
    }
  });

  api.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response.status == 401) {
        window.localStorage.removeItem("userljrs");
        router.push("/login");
      }
      return Promise.reject(error);
    }
  );

  return api;
};
